// extracted by mini-css-extract-plugin
export default {"Embed__Youtube":"Video-styles__Embed__Youtube__jhNxC"};